export const SUPPRESS_EDU_FORM_IDS = ['6', '27', '31', '677', '890', '891'] as const;

/**
 * Matches an educational domain in any country, not just the US `.edu` TLD:
 * a domain whose public suffix is `.edu` (harvard.edu) or `.edu.<cc>`
 * (unam.edu.mx, monash.edu.au, usp.edu.br...). The optional `(\.[a-z]{2,})?`
 * tail captures the country code while the trailing `$` keeps `foo.education`
 * and `edu.com` from matching.
 */
export const isEduEmail = (email: string | null | undefined): boolean =>
  /\.edu(\.[a-z]{2,})?$/i.test((email ?? '').trim());
